import React from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';

export const EditActions = ({ onCancel, onSave, disabled }) => (
	<>
		<IconButton
			sx={{ marginLeft: 5 }}
			color='primary'
			aria-label='cancel'
			disabled={disabled}
			edge='start'
			onClick={onCancel}
		>
			<CloseIcon />
		</IconButton>
		<IconButton color='primary' aria-label='save' onClick={onSave}>
			<DoneIcon />
		</IconButton>
	</>
);
